<template>
  <div class="main-tain">
    <div class="content">
      <img
        class="main-tain-img"
        src="./../assets/img/main-tain.png"
        :alt="$t('mainTain.img_alt')"
      />
      <p class="system">{{ $t("mainTain.system_maintain") }}</p>
      <p class="maintain-words">{{ $t("mainTain.maintain_words") }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "mainTain",
};
</script>
<style scoped>
.main-tain {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
}
.content {
  position: absolute;
  left: 50%;
  margin-left: -25.7rem;
  top: 50%;
  margin-top: -16.1rem;
  width: 51.5rem;
  text-align: center;
  background: #fff;
  box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.43);
  border-radius: 5px;
}
.main-tain-img {
  margin-top: 2.8rem;
}
.system {
  margin-top: 0.9rem;
  color: #2b2626;
  font-weight: bold;
  font-size: 1.6rem;
}
.maintain-words {
  font-size: 1.4rem;
  color: #2b2626;
  margin-top: 1.7rem;
  padding: 0 1rem;
  margin-bottom: 6rem;
}
</style>



// WEBPACK FOOTER //
// src/base/mainTain.vue